<template>
  <div class="update-pwd-dialog">
    <el-dialog
      width="620px"
      title="修改密码"
      :visible.sync="showDialog"
      :append-to-body="true"
      @closed="closePasswordDialog"
      :close-on-click-modal="false"
      :show-close="forceUpdatePassword ? false : true"
      :close-on-press-escape="false"
    >
      <div class="alert-tips">
        <el-alert
          v-show="forceUpdatePassword"
          :closable="false"
          title="当前密码已超过有效期，请重新设置密码"
          type="warning"
          show-icon
        />
      </div>
      <el-form
        label-position="right"
        label-width="140px"
        ref="formPassword"
        :model="formPassword"
        :rules="rules"
      >
        <el-form-item label="原密码/重置后密码" prop="oldPassword">
          <el-input
            :type="oldPasswordType"
            v-model="formPassword.oldPassword"
            placeholder="请输入"
            ref="oldPassword"
            maxlength="20"
          >
          </el-input>
          <span class="show-pwd" @click="showPwd('oldPassword')">
            <svg-icon
              :icon-class="oldPasswordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
          <span
            class="icon-clear"
            @click="
              () => {
                formPassword.oldPassword = '';
                $refs.oldPassword.focus();
              }
            "
          >
            <svg-icon icon-class="clear" />
          </span>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            :type="newPasswordType"
            v-model="formPassword.newPassword"
            placeholder="请输入"
            ref="newPassword"
            maxlength="20"
          />
          <span class="show-pwd" @click="showPwd('newPassword')">
            <svg-icon
              :icon-class="newPasswordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span>
          <span
            class="icon-clear"
            @click="
              () => {
                formPassword.newPassword = '';
                $refs.newPassword.focus();
              }
            "
          >
            <svg-icon icon-class="clear" />
          </span>
        </el-form-item>

        <el-form-item label="重复新密码" prop="repeatNewPassword">
          <el-input
            :type="repeatNewPasswordType"
            v-model="formPassword.repeatNewPassword"
            placeholder="请输入"
            ref="repeatNewPassword"
            maxlength="20"
          />

          <span class="show-pwd" @click="showPwd('repeatNewPassword')">
            <svg-icon
              :icon-class="
                repeatNewPasswordType === 'password' ? 'eye' : 'eye-open'
              "
            />
          </span>
          <span
            class="icon-clear"
            @click="
              () => {
                formPassword.repeatNewPassword = '';
                $refs.repeatNewPassword.focus();
              }
            "
          >
            <svg-icon icon-class="clear" />
          </span>
        </el-form-item>

        <el-form-item>
          <PasswordStrength :password="formPassword.newPassword" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          v-if="forceUpdatePassword ? false : true"
          @click.native="closePasswordDialog"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click.native="submitPassword('formPassword')"
          :loading="dialogSubmitLoading"
           v-throttle>保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { userChangePwdConfirm } from '@/api/users';
  import PasswordStrength from './PasswordStrength';
  import { encrypt } from '@/utils/auth';

  export default {
    components: {
      PasswordStrength
    },
    props: {
      forceUpdatePassword: {
        type: Boolean,
        default: false
      }
    },
    data() {
      // let OldValidatePassword = (rule, value, callback) => {
      //   const reg = /^([a-zA-Z0-9\_\-\@\.]){8,20}$/i;
      //   if (!reg.test(value)) {
      //     callback(new Error('密码8-20位只能由字母、数字及符号.-_@组成'));
      //   } else {
      //     callback();
      //   }
      // };
      let validatePassword = (rule, value, callback) => {
        const NewReg =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\.])[a-zA-Z\d!@#$%^&*()_+\.]{8,20}$/;
        if (!NewReg.test(value)) {
          callback(
            new Error(
              '密码长度最小8位最大20位,应包含有大小写字母、数字和特殊符号'
            )
          );
        } else {
          callback();
        }
      };
      return {
        showDialog: false,
        formPassword: {
          oldPassword: '',
          newPassword: '',
          repeatNewPassword: ''
        },
        rules: {
          oldPassword: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入原密码'
            }
          ],
          newPassword: [
            {
              required: true,
              validator: validatePassword,
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (this.rules.repeatNewPassword !== '') {
                  this.$refs.formPassword.validateField('repeatNewPassword');
                }
                callback();
              }
            }
          ],
          repeatNewPassword: [
            {
              required: true,
              validator: validatePassword,
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value === this.formPassword.newPassword) {
                  callback();
                } else {
                  callback(new Error('两次输入的密码不一致'));
                }
              }
            }
          ]
        },
        dialogSubmitLoading: false,
        oldPasswordType: 'password',
        newPasswordType: 'password',
        repeatNewPasswordType: 'password'
      };
    },
    methods: {
      showPwd(type) {
        if (this[`${type}Type`] === 'password') {
          this[`${type}Type`] = '';
        } else {
          this[`${type}Type`] = 'password';
        }
        this.$nextTick(() => {
          this.$refs[type].focus();
        });
      },
      closePasswordDialog() {
        this.showDialog = false;
        this.formPassword.oldPassword = '';
        this.formPassword.newPassword = '';
        this.formPassword.repeatNewPassword = '';
        this.$refs['formPassword'].clearValidate();
        this.$refs['formPassword'].resetFields();
        this.oldPasswordType =
          this.newPasswordType =
          this.repeatNewPasswordType =
            'password';
      },
      submitPassword(formName) {
        console.log('newPassword', this.formPassword.newPassword);
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            try {
              let res = await userChangePwdConfirm({
                oldPwdEncrypt: encrypt(this.formPassword.oldPassword),
                pwdEncrypt: encrypt(this.formPassword.newPassword),
                tempSession: this.forceUpdatePassword
              });
              if (!res) {
                this.$message({
                  message: `密码修改成功`,
                  type: 'success'
                });
                this.showDialog = false;
                location.reload();
              } else {
                this.$message.error('密码修改失败,请重试');
              }
            } catch (e) {
              console.error(e);
            }
          } else {
            return false;
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__body {
      max-height: 100%;
      padding: 20px;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      .el-form {
        .el-form-item {
          .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
    .el-dialog__footer {
      padding-top: 0px;
    }
  }

  .el-form-item {
    & > ::v-deep .el-form-item__content {
      .show-pwd {
        position: absolute;
        right: 44px;
        top: 4px;
        font-size: 16px;
        color: #889aa4;
        cursor: pointer;
        user-select: none;
      }
      .icon-clear {
        position: absolute;
        right: 10px;
        top: 4px;
        font-size: 16px;
        color: #889aa4;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .update-pwd-dialog {
    background: #fff;
  }
  .alert-tips {
    margin-bottom: 16px;
  }
</style>
